import { call, put, fork, take, race, select } from 'redux-saga/effects';
import get from 'lodash/get';
import camelCase from 'lodash/camelCase';
import {
  START_POLLING_FOR_QUERY,
  STOP_POLLING_FOR_QUERY,
  stopPollingForQueryStatus,
} from './actions';
import { resourceDetailReadRequest } from '../resource/actions';
import urlTransform from '../../services/ant-redux/urlTransform';

const delay = duration =>
  new Promise(resolve => {
    setTimeout(() => resolve(true), duration);
  });

/**
 * Saga worker.
 */
export function* pollForQuery({ uuid, endpoint = 'the-trade-desk/check', params = {} }) {
  while (true) {
    const promiseResponse = yield put(resourceDetailReadRequest(endpoint, params, { uuid }));
    const responseUuid = yield promiseResponse;

    const state = yield select();
    const pollState = get(
      state,
      ['entities', camelCase(urlTransform(endpoint, params)), responseUuid],
      {}
    );

    if (
      pollState &&
      pollState.totalRowsInQuery &&
      pollState.attemptedItems === pollState.totalRowsInQuery
    ) {
      yield put(stopPollingForQueryStatus(uuid));
    }
    yield call(delay, 10000);
  }
}

/**
 * Saga watcher.
 */
export function* watchPollingForQuery() {
  while (true) {
    const { payload } = yield take(START_POLLING_FOR_QUERY);
    yield race([call(pollForQuery, payload), take([STOP_POLLING_FOR_QUERY])]);
  }
}

export default function*() {
  yield fork(watchPollingForQuery);
}
